import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Phone, ShieldCheck } from "lucide-react";
import { IMAGES, PHONE, PHONE_HREF } from "../lib/content";
import { scrollToId } from "../hooks/useSmoothScroll";

export const CTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);

  return (
    <section ref={ref} className="relative overflow-hidden">
      <motion.div style={{ y, scale: 1.2 }} className="absolute inset-0 z-0">
        <img src={IMAGES.ctaBg} alt="" className="h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a1410] via-black/85 to-[#1a1410]" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-[1100px] px-5 sm:px-8 py-28 sm:py-40 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-[11px] uppercase tracking-[0.3em] text-amber-500"
        >
          Call To Action
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.05 }}
          className="mt-6 font-serif font-black tracking-tight text-white text-4xl sm:text-6xl leading-[1.02]"
        >
          Ready To Take The <span className="text-gold-foil">Next Step?</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.12 }}
          className="mt-6 text-lg font-light text-zinc-300 max-w-2xl mx-auto"
        >
          Whether you're looking to recover lost assets, improve your credit,
          invest in real estate, or launch your next business — we're here to
          help.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.18 }}
          className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-5"
        >
          <button
            onClick={() => scrollToId("contact")}
            data-testid="cta-consult-btn"
            className="bg-gold-foil text-black text-[13px] font-bold tracking-[0.14em] uppercase px-10 py-4 hover:brightness-110 transition-all duration-300"
          >
            Schedule Your Free 15-Minute Consultation
          </button>
          <a
            href={PHONE_HREF}
            className="flex items-center gap-3 text-amber-300 text-[13px] font-bold tracking-[0.14em] uppercase border border-amber-500/40 px-10 py-4 hover:bg-amber-500 hover:text-black transition-colors duration-300"
          >
            <Phone className="h-4 w-4" /> {PHONE}
          </a>
        </motion.div>

        <div className="mt-8 flex items-center justify-center gap-2 text-sm text-zinc-500">
          <ShieldCheck className="h-4 w-4 text-amber-500" /> 100% Confidential ·
          Nationwide Service
        </div>
      </div>
    </section>
  );
};
